"use client";

import { useEffect, useRef, useState } from "react";

export function useInViewOnce(
    options: IntersectionObserverInit = {
        threshold: 0.2,
        rootMargin: "0px 0px -15% 0px",
    },
) {
    const ref = useRef<HTMLDivElement | null>(null);
    const [inView, setInView] = useState(false);

    useEffect(() => {
        if (!ref.current || inView) return;
        const io = new IntersectionObserver(([e]) => {
            if (e.isIntersecting) {
                setInView(true);
                io.disconnect();
            }
        }, options);
        io.observe(ref.current);
        return () => io.disconnect();
    }, [inView, options]);

    return { ref, inView };
}
